import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

/**
 * Asked before a report runs with no filters at all: it then covers every
 * specimen the organization has imaged, which is rarely what was meant and
 * can take a while.
 */
export const UnfilteredWarning = ({ open, onCancel, onRunAnyway }) => (
  <Dialog open={open} onClose={onCancel} aria-labelledby="unfiltered-warning-title" maxWidth="xs">
    <DialogTitle id="unfiltered-warning-title">Run without filters?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        No species, dates or other filters are set, so this report covers every specimen your organization has
        imaged. It can take a while to load.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button onClick={onRunAnyway} variant="contained" disableElevation>
        Run anyway
      </Button>
    </DialogActions>
  </Dialog>
);
